import { IConditionFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';

export const checkAllAnyPredicates = (
  conditions: IConditionFieldsFragment[],
) => {
  return conditions.every((condition) =>
    condition.predicates.every(
      (predicate) =>
        predicate.__typename === 'SimplePredicate' &&
        predicate.operands.__typename === 'ValueOperands' &&
        predicate.operands.values.every(
          (value) => value.__typename === 'AnyFieldValue',
        ),
    ),
  );
};
